import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/web.dom.iterable";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { TreeMixin, itemTypeLoadMore, itemTypeDefault } from './mixin';
import ApiService from '../../../../services/apiService';
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import clone from 'lodash/clone';
import get from 'lodash/get';
var itemTypeStatesRoot = 'DtwinStatesRoot.';
var itemTypeState = 'DtwinState.';
export default {
  name: 'CoreDtwinTreeStates',
  mixins: [TreeMixin],
  props: {
    searchEnabled: {
      type: Boolean,
      required: false,
      default: function _default() {
        return true;
      }
    },
    selectedStates: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      statesForDtwins: {}
    };
  },
  computed: _objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions'])),
  watch: {
    selectedStates: function selectedStates() {
      this.cleanTreeSelection();
    }
  },
  created: function created() {
    this.loadDescendents = false;
    this.itemTypeLoadMore = itemTypeLoadMore;
    this.itemTypeState = itemTypeState;
    this.itemTypeStatesRoot = itemTypeStatesRoot;
  },
  mounted: function mounted() {
    this.initTree();
  },
  methods: {
    initTree: function initTree() {
      this.twinTreeItems = [];
      this.twinItemMapping = {};
      this.twinItemMapping[this.parentId] = {}; // an active node is specified, so make sure to load the tree-structure to accomodate this node
      // might not be on root-level, so there is special handling required to have it displayed right away

      if (this.activeDtwinId) {
        this.fetchPartialTree(this.activeDtwinId);
      } else {
        this.fetchChildren({
          id: this.parentId
        }, true);
      }
    },
    fetchChildren: function fetchChildren(item) {
      var initially = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var statesPromise = this.fetchChildrenStates(item);

      if (statesPromise) {
        return statesPromise;
      }

      return this.fetchChildrenDefault(item.id, 0, initially);
    },
    cleanTreeSelection: function cleanTreeSelection() {
      var _this = this;

      var iterateChildren = function iterateChildren(children) {
        children.forEach(function (child) {
          if (typeof child.id === 'string' && _this.itemType(child) === itemTypeState) {
            var stateId = parseInt(child.id.replace(itemTypeState, ''));

            if (_this.selectedStates.findIndex(function (s) {
              return s.id === stateId;
            }) < 0) {
              child.selected = false;
            }
          } else {
            if (child.children) {
              iterateChildren(child.children);
            }
          }
        });
      };

      iterateChildren(this.twinTreeItems); // force a refresh

      this.twinTreeItems = clone(this.twinTreeItems);
    },
    processTreeItems: function processTreeItems(items) {
      var _this2 = this;

      // regular twins need to have a "states"-child added, that in turn contains all states with checkboxes
      // so handle every item that is NOT a state-item by manipulating their children
      this.processTreeItemsStates(items.filter(function (item) {
        return !_this2.treeItemIsState(item);
      })); // next handle all state-items, i.e. put pagination there if needed and stuff

      this.processTreeItemsDefault(items.filter(function (item) {
        return _this2.treeItemIsState(item);
      }));
    },
    itemType: function itemType(item) {
      var itemId = get(item, 'id');

      if (typeof itemId === 'string') {
        if (itemId.startsWith(itemTypeLoadMore)) {
          return itemTypeLoadMore;
        }

        if (itemId.startsWith(itemTypeStatesRoot)) {
          return itemTypeStatesRoot;
        }

        if (itemId.startsWith(itemTypeState)) {
          return itemTypeState;
        }
      }

      return itemTypeDefault;
    },
    getTwinTreeIcon: function getTwinTreeIcon(dtwin) {
      // special case for the "Load More" tree item
      if (this.itemType(dtwin) === itemTypeLoadMore) {
        return this.getTwinTreeIconDefault(dtwin);
      }

      return this.getTwinTreeIconStates(dtwin);
    },
    // --------
    // STATES
    // --------
    fetchChildrenStates: function fetchChildrenStates(item) {
      var _this3 = this;

      if (this.itemType(item) === itemTypeStatesRoot) {
        return this.fetchBindingsForDtwinStateItems([item]).then(function () {
          _this3.refreshTree();
        });
      }

      return null;
    },
    fetchBindingsForDtwinStateItems: function fetchBindingsForDtwinStateItems(items) {
      var _this4 = this;

      var itemsToBeFetched = items.filter(function (item) {
        var dtwinId = item.parentId;
        var dtwinStates = _this4.statesForDtwins[dtwinId];

        if (dtwinStates) {
          if (dtwinStates.length === 0) {
            _this4.removeStatesElement(_this4.twinTreeItems, dtwinId);
          } else {
            var children = item.children;

            if (children) {
              dtwinStates.forEach(function (state) {
                if (!children.find(function (child) {
                  return child.id === state.id;
                })) {
                  children.push(state);
                }
              });
            }
          }

          return false;
        }

        return true;
      });
      var dtwinIds = itemsToBeFetched.map(function (item) {
        return item.parentId;
      });

      if (dtwinIds.length > 0) {
        return ApiService.digitalTwinsFetchStates(this, dtwinIds, ['bare']).then(function (states) {
          states.forEach(function (state) {
            if (!_this4.statesForDtwins[state.dtwinId]) {
              _this4.statesForDtwins[state.dtwinId] = [];
            }

            _this4.statesForDtwins[state.dtwinId].push(state);
          });
          dtwinIds.forEach(function (dtwinId) {
            var dtwinStates = get(_this4.statesForDtwins, dtwinId, []);
            dtwinStates.forEach(function (state) {
              state.title = state.properties.title;
              state.selected = _this4.stateIsSelected(state);
              state.parentId = state.id;

              if (!"".concat(state.id).startsWith(itemTypeState)) {
                state.id = itemTypeState + state.id;
              }
            });
            _this4.statesForDtwins[dtwinId] = dtwinStates.sort(function (state1, state2) {
              return state1.key < state2.key ? -1 : 1;
            });
            dtwinStates = _this4.statesForDtwins[dtwinId];

            if (dtwinStates.length === 0) {
              _this4.removeStatesElement(_this4.twinTreeItems, dtwinId);
            } else {
              var children = items.find(function (item) {
                return item.parentId === dtwinId;
              }).children;

              if (children) {
                dtwinStates.forEach(function (state) {
                  if (!children.find(function (child) {
                    return child.id === state.id;
                  })) {
                    children.push(state);
                  }
                });
              }
            }

            _this4.statesForDtwins[dtwinId] = dtwinStates;
          });
          _this4.twinTreeItems = clone(_this4.twinTreeItems);
        });
      }

      return Promise.resolve();
    },
    processTreeItemsStates: function processTreeItemsStates(items) {
      var _this5 = this;

      var fetchStatesForChildren = [];
      items.forEach(function (item) {
        // when children are requested/processed, their respective states are loaded as well (down here),
        // BUT they are not displayed yet, along with the true children of the twin, because the tree-node has not been opened yet
        // for the vuetify-tree to perform async loading, the element needs to have an empty `children` array, this is where
        // it gets compliated: if it is filled already, vuetify does not perform any async fetching any more,
        // if it does not exist, the node gets displayed as leaf without children
        // so we can only add the states-node as child of an item that already has been fetched, once its children are fetched
        // THUS, wait until a child is processed and then add the states-root-node as first child
        // check if the parent-element of item needs to have the twinStateChild added
        var parentTwin = _this5.twinItemMapping[item.parentId];
        var parentStatesNode = _this5.twinItemMapping[itemTypeStatesRoot + item.parentId];

        if (parentTwin && parentStatesNode) {
          if (parentTwin.children && (parentTwin.children.length === 0 || typeof parentTwin.children[0].id !== 'string')) {
            parentTwin.children = [parentStatesNode].concat(parentTwin.children);
          }
        }

        if (item.id && typeof item.id !== 'string') {
          _this5.twinItemMapping[item.id] = item;
          var twinStateChild = {
            id: itemTypeStatesRoot + item.id,
            parentId: item.id,
            title: _this5.$i18n_t('DigitalTwin.DigitalTwin.dataStates'),
            children: []
          };
          fetchStatesForChildren.push(twinStateChild);
          _this5.twinItemMapping[twinStateChild.id] = twinStateChild;

          if (!item.children) {
            item.children = [];
          } // this item has no children, so add the "STATES" child, if not added already


          if (item.childCount === 0) {
            item.children = [twinStateChild];
            return null;
          } // otherwise this item SHOULD have children, so add the "STATES" child once there is at least 1 valid child
          // otherwise the async lazy loading will not trigger any more


          if (item.children.length && typeof item.children[0].id !== 'string') {
            item.children = [twinStateChild].concat(item.children);
          }
        }
      });
      this.fetchBindingsForDtwinStateItems(fetchStatesForChildren);
    },
    getTwinTreeIconStates: function getTwinTreeIconStates(dtwin) {
      if (this.itemType(dtwin) === itemTypeStatesRoot) {
        return 'fal fa-network-wired';
      }

      return undefined;
    },
    treeItemIsState: function treeItemIsState(item) {
      return this.itemType(item) === itemTypeState;
    },
    removeStatesElement: function removeStatesElement(treeItems, dtwinId) {
      var _this6 = this;

      delete this.twinItemMapping[itemTypeStatesRoot + dtwinId];
      var foundDtwinNode = treeItems.find(function (item) {
        return item.id === parseInt(dtwinId);
      });

      if (foundDtwinNode) {
        // delete the "STATES" child for this node, identifiable by a 'twin_states' prefix
        foundDtwinNode.children = foundDtwinNode.children.filter(function (child) {
          return _this6.itemType(child) !== itemTypeStatesRoot;
        });
        return true;
      }

      treeItems.forEach(function (item) {
        if (item.children) {
          if (_this6.removeStatesElement(item.children, dtwinId)) {
            return;
          }
        }
      });
    },
    stateSelectionToggled: function stateSelectionToggled(item) {
      var cleanItem = cloneDeep(item);
      cleanItem.id = cleanItem.parentId;

      if (typeof cleanItem.id === 'string') {
        cleanItem.id = parseInt(cleanItem.id.replace(itemTypeState, ''));
      }

      if (this.stateIsSelected(cleanItem)) {
        // remove from list
        this.$emit('deselectedState', cleanItem);
      } else {
        // add to list
        this.$emit('selectedState', cleanItem);
      }
    },
    stateIsSelected: function stateIsSelected(item) {
      return this.selectedStates.find(function (selectedState) {
        return selectedState.dtwinId === item.dtwinId && selectedState.id === item.id;
      }) !== undefined;
    }
  }
};